var map = {
	"./1 Thumbnail, title_ Musren BNN RI di Magelang Akselerasi Menuju Indonesia Bersinar.jpeg": 31045,
	"./10 Thumbnail, title_ Pusat Laboratorium Narkotika BNN RI Raih BPKN Award 2022.jpg": 40182,
	"./11 Thumbnail, title_ Gala Dinner dan Pengumuman Pemenang Grand Prix Menutup Bali International Choir Festival.jpg": 55028,
	"./2 Thumbnail, title_ Kepala BNN Resmikan Renovasi dan Modernisasi Klinik.jpg": 58331,
	"./3 Thumbnail, title_ Jangkau Wilayah Kalimantan, BNN RI Dirikan Laboratorium Narkotika di Samarinda.png": 95492,
	"./4 Thumbnail, title_ Keempat di Indonesia, BNN bangun laboratorium narkotika di Bangkalan.jpg": 49227,
	"./5 Thumbnail, title_ WTP untuk Laporan Keuangan BNN RI T.A 2022.jpg": 61937,
	"./6 Thumbnail, title_ BNN RI Didukung Penuh Komisi III DPR RI Terkait Program Kerja T.A. 2024.jpg": 39179,
	"./7 Thumbnail, title_ Temui Para Awak Media di Bengkulu, Kepala Biro Humpro BNN RI Bangun Sinergi Publikasi P4GN.jpg": 6705,
	"./8 Thumbnail, title_ BSSN Fasilitasi Sertifikat Elektronik untuk Mendukung Program P4GN BNN.jpg": 39311,
	"./9 Thumbnail, title_ BNN RI Sita 33 KG Narkotika Dari 10 Wilayah Di Indonesia.jpg": 3032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20314;